import { rHandler } from '@/plugins/RHandler';
import { apiService } from '@/services/APIService';
import { objectsRHandler, DEFAULT_PARAMS } from '@/utils/objectsRHandler';
import Expert from '../list/expert';

const API_PATH = 'expert';

export const ExpertManager = {
  objects: objectsRHandler(`${API_PATH}s`, Expert),

  get requests() {
    const path = `${API_PATH}-requests`;

    return {
      invite: ({ params } = DEFAULT_PARAMS) => rHandler(
        apiService.post(`${path}/send-by-org`, params),
        (response) => ({ response }),
        (error) => ({ error }),
      ),
      cancelInvite: ({ params } = DEFAULT_PARAMS) => rHandler(
        apiService.post(`${path}/cancel-by-organizer-request`, params),
        (response) => ({ response }),
        (error) => ({ error }),
      ),
    };
  },

  invite: ({ data } = DEFAULT_PARAMS) => rHandler(
    apiService.post(`${API_PATH}s/invite`, data),
    (response) => ({ response }),
    (error) => ({ error }),
  ),

  getInviteData: ({ params } = DEFAULT_PARAMS) => rHandler(
    apiService.get(`${API_PATH}s/invite`, params),
    (response) => ({ response }),
    (error) => ({ error }),
  ),
};
